<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div slot="footer">
            <b-row>
              <b-col sm="12">
                <router-link tag="button" class="btn btn-block btn-primary float-right col-2" role="button"
                             :to="{name: 'jasperNewRoute'}">{{ $t('page.generic.create') }}
                </router-link>
              </b-col>
            </b-row>
          </div>
          <b-table :stacked="stacked" :dark="dark" :hover="hover" :striped="striped" :bordered="bordered" :small="small"
                   :fixed="fixed"
                   responsive="sm" :items="items" :fields="captions" :current-page="currentPage" :per-page="perPage">
            <template slot="actions" slot-scope="data">
              <div class="btn-group" role="group">
                <router-link tag="button" class="btn btn-primary fa fa-search" v-b-tooltip.hover :title="$t('actions.show')"
                             :to="{name: 'jasperShowRoute', params:{uri: data.item.uri}}">
                </router-link>
                <router-link tag="button" class="btn btn-warning fa fa-edit" v-b-tooltip.hover :title="$t('actions.edit')"
                             :to="{name: 'jasperEditRoute', params:{uri: data.item.uri}}">
                </router-link>
              </div>
            </template>
          </b-table>
          <nav>
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev"
                          next-text="Next" hide-goto-end-buttons/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import miniToastr from 'mini-toastr' //ES6
  import PageTitle from '../../components/PageTitle'
  import JasperService from "@/services/JasperService"

  const jasperService = JasperService.build();

  export default {
    name: 'JasperList',
    components: {
      PageTitle
    },
    data() {
      return {
        deleteModal: false,
        currentPage: 1,
        items: []
      }
    },
    props: {
      hover: {
        type: Boolean,
        default: true
      },
      striped: {
        type: Boolean,
        default: false
      },
      stacked: {
        type: String,
        default: 'sm'
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      },
      tableData: {
        type: [Array, Function],
        default: () => []
      },
      fields: {
        type: [Array, Object],
        default: () => [
          {key: 'filename', label: 'Filename', sortable: true},
          {key: 'path', label: 'Percorso', sortable: true},
          {key: 'uri', label: 'URI', sortable: true},
          {key: 'total', label: 'Total', sortable: true},
          {key: 'actions', label: '', sortable: false},
        ]
      },
      perPage: {
        type: Number,
        default: 7
      },
      dark: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      totalRows: function () {
        return this.getRowCount()
      },
      captions: function () {
        return this.fields
      }
    },
    created() {
      this.fetchData();
      miniToastr.init();
      miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'})
    },
    methods: {
      async fetchData() {
        let available = await jasperService.available();
        let enabled = await jasperService.enabled();

        this.items = available.map(e => (
          {
            'uri': e,
            'filename': e.substring(e.lastIndexOf("/") + 1),
            'path': e.substring(e.indexOf("/"), e.lastIndexOf("/")),
            'total': (enabled.find(elem => elem[0] === e) || [0, 0])[1]
          })
        )

      },
      getRowCount: function () {
        return this.items.length
      }
    }
  }
</script>
